import React from 'react';

interface ScorecardProps {
  title: string;
  count: number;
  color?: string;
  onClick?: () => void;
  isActive?: boolean;
}

/**
 * Scorecard Component
 * Displays a count metric with optional click-to-filter functionality
 * 
 * @param title - Display label (e.g., "Total Tasks", "TODO")
 * @param count - Numeric value to display
 * @param color - Optional color for the count (default: #4CAF50)
 * @param onClick - Optional click handler for filtering
 * @param isActive - Whether this card represents the active filter
 */
export const Scorecard: React.FC<ScorecardProps> = ({ 
  title, 
  count, 
  color = '#4CAF50', 
  onClick, 
  isActive = false 
}) => {
  return (
    <div
      className={`scorecard ${onClick ? 'scorecard-clickable' : ''} ${isActive ? 'scorecard-active' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-pressed={onClick ? isActive : undefined}
    >
      <div className="scorecard-title">{title}</div>
      <div className="scorecard-count" style={{ color }}>{count}</div>
    </div>
  );
};
